
const TextareaField = ({
    placeholder,
    name,
    value,
    onChange,
    rows = 4,
}) => {
    return (
        <div className="relative w-full">

            <textarea
                name={name}
                rows={rows}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                className="w-full py-3 text-black border resize-none ps-3 dark:text-white bg-bg-light-primary dark:bg-bg-dark-primary border-border-light dark:border-border-dark rounded-xl focus:outline-none focus:ring focus:ring-primary-light dark:focus:ring-primary"
            />
        </div>
    );
};

export default TextareaField;
